module.exports = __webpack_public_path__ + "img/userIcon.938ab5f7.svg";